<template>
<!-- TODO: need two types of this thing -->
<!-- modal should act the same, but button is different -->
  <component :is="componentType" @click.stop="open = true" variant="link">
    <template v-if="componentType == 'b-dropdown-item'">
      <b-icon :icon="section.Icon" variant="info" aria-hidden="true"></b-icon>
      {{ section.DisplayName }}
    </template>
    <template v-else>
      <b-icon icon="pencil-square" :variant="changed ? 'danger' : 'info'" aria-hidden="true"></b-icon>
    </template>
    <b-modal
      no-close-on-esc
      size="lg"
      :title="section.DisplayName"
      :visible="open"
      @hide="close()"
      centered>
        <editor-field-list :fields="columns"
          :obj="obj" :originalObj="originalObj"
          :parentObj="parentObj"
          @changed="(changed, i) => onFieldChanged(i, changed)"
          @validated="(valid, i) => onFieldValidated(i, valid)"
          :fieldCols="fieldCols"
          :section="section"
          @hook:mounted="sectionMounted"
          :addChildObject="addChildObject"
          :addChildObjects="addChildObjects"
          :removeChildObject="removeChildObject"
          :readdChildObject="readdChildObject"
          @save="(obj, section) => save(obj, section)"
        />
      <template #modal-footer>
        <b-button v-if="changed" variant="primary" @click.stop="save(obj, section)">
          Save
        </b-button>
        <button @click.stop="close()" type="button" class="btn btn-secondary" data-dismiss="modal">
          Cancel
        </button>
      </template>
    </b-modal>
  </component>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins, Emit } from 'vue-property-decorator'
import EditorFieldList from './editor-field-list.vue'

import MxEditorComponent from '@/mixins/editor-component'
import { EditorSection } from '@/store/entity/types'
import { EditBase } from '@/store/editor/types'

@Component({
  components: {
    'editor-field-list': EditorFieldList, // () => import('./editor-field-list.vue'), // lamda because vue gets confused when nesting a control in itself
  },
})
export default class extends Mixins(MxEditorComponent) {
  public changed = false
  public valid = true

  // simple array, since we don't add/remove fields on the fly, index doesn't change
  public changedFields: boolean[] = []
  public validatedFields: boolean[] = []
  public currentTab = 0
  public open = false

  @Prop()
  public section!: EditorSection // the field we're editing

  @Prop()
  public fieldCols!: number

  @Prop()
  public hideBlank!: boolean

  @Prop({ default: false })
  public modalOpen!: boolean

  @Prop()
  public cancel!: any

  public mounted() {
    Vue.set(this, 'changedFields', new Array(this.section.Fields.length).fill(false))
    Vue.set(this, 'validatedFields', new Array(this.section.Fields.length).fill(true))
  }

  public save(obj: EditBase, section: EditorSection) {
    this.open = false
    this.$emit('save', obj, section)
    this.changed = false
  }

  public removeItem(obj: EditBase) {
    this.$emit('removeItem', obj)
  }

  public onFieldChanged(i: number, changed: boolean) {
    this.changedFields[i] = changed
    this.changed = this.changedFields.some(v => v)
    this.$emit('changed', this.changed)
  }

  public onFieldValidated(i: number, valid: boolean) {
    this.validatedFields[i] = valid
    this.valid = !this.validatedFields.some(v => !v)
    this.$emit('validated', this.valid)
  }

  public sectionMounted() {
    this.$emit('sectionMounted')
  }

  get columns() {
    return this.section.Fields // .filter(c => !c.IsId) // && c.EditorType !== 'sub-item'
  }

  // if this is a Modal section then we are a dropdown item
  // if this is not, then we're an edit button
  get componentType() {
    return this.section.SectionType === 'Modal' ? 'b-dropdown-item' : 'b-button'
  }

  @Emit('close')
  public close() {
    this.open = false
    this.cancel()
    this.changed = false
    // do nothing but Emit.
  }
}
</script>
<style scoped>
</style>
